import { Flex, Heading, SimpleGrid, Text } from '@chakra-ui/react';
import firebase from 'firebase';
import React from 'react';
import { CourseCategory, FbCourse, FirebaseConfig } from '../../types/types';
import { CourseItem } from './CourseItem';

interface WeekdayItemProps {
  weekday: FbCourse;
  currentUser: firebase.User;
  history: any;
  config: FirebaseConfig;
  categories: CourseCategory[];
}

export const WeekdayItem: React.FC<WeekdayItemProps> = ({
  weekday,
  currentUser,
  history,
  config,
  categories,
}) => (
  <Flex direction="column">
    <Heading size="md" mb={6}>
      {weekday.date.locale('de').format('dddd, D. MMMM')}
      {weekday.isToday ? ' (heute)' : ''}
    </Heading>

    {!weekday.courses.length ? (
      <Text>
        {weekday.isToday ? 'Am heutigen' : 'An diesem'} Tag sind keine{' '}
        {weekday.isToday && 'weiteren'} Kurse geplant.
      </Text>
    ) : (
      <SimpleGrid columns={[1, 1, 2]} gap={4}>
        {weekday.courses.map((course, idx) => (
          <CourseItem
            key={`course-${course.uid}-${course.startMoment}`}
            course={course}
            currentUser={currentUser}
            history={history}
            config={config}
            category={
              categories.find(
                (category) => category.uid === course.courseCategoryId
              )?.title
            }
          />
        ))}
      </SimpleGrid>
    )}
  </Flex>
);
